export default [
  {
    path: "/member-invite/:businessMemberInviteId",
    component: () => import("@/views/memberInvite/MemberInvite.vue"),
    meta: {
      hideNav: true,
      preventInit: true,
    },
  },
];
